import { Helmet } from 'react-helmet'
import classNames from 'classnames'
import { initialize } from '../store/pagedata'
import styles from '../styles/privacy.module.scss'
import useDarkMode from 'use-dark-mode'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'

const Recs = () => {
  const darkMode = useDarkMode(false)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(initialize())
  }, [])

  return (
    <>
      <Helmet>
        <meta name='description' content='EDHREC Privacy Policy' />
        <meta name='keywords' content='EDHREC,privacy,policy' />
        <title>Privacy Policy | EDHREC</title>
      </Helmet>
      <div className={classNames({ [styles.dark]: darkMode.value })}>
        <h4 className='page-heading'>Privacy Policy</h4>
        <div className={styles.container}>
          <h3>Mediavine Programmatic Advertising (Ver 1.1)</h3>
          <p>
            The Website works with Mediavine to manage third-party
            interest-based advertising appearing on the Website. Mediavine
            serves content and advertisements when you visit the Website, which
            may use first and third-party cookies. A cookie is a small text file
            which is sent to your computer or mobile device (referred to in this
            policy as a “device”) by the web server so that a website can
            remember some information about your browsing activity on the
            Website.
          </p>
          <p>
            First party cookies are created by the website that you are
            visiting. A third-party cookie is frequently used in behavioral
            advertising and analytics and is created by a domain other than the
            website you are visiting. Third-party cookies, tags, pixels, beacons
            and other similar technologies (collectively, “Tags”) may be placed
            on the Website to monitor interaction with advertising content and
            to target and optimize advertising. Each internet browser has
            functionality so that you can block both first and third-party
            cookies and clear your browser’s cache. The "help" feature of the
            menu bar on most browsers will tell you how to stop accepting new
            cookies, how to receive notification of new cookies, how to disable
            existing cookies and how to clear your browser’s cache. For more
            information about cookies and how to disable them, you can consult
            the information at{' '}
            <a
              href='https://www.allaboutcookies.org/manage-cookies/'
              target='_blank'
              rel='noreferrer noopener nofollow'
            >
              All About Cookies
            </a>
            .
          </p>
          <p>
            Without cookies you may not be able to take full advantage of the
            Website content and features. Please note that rejecting cookies
            does not mean that you will no longer see ads when you visit our
            Site. In the event you opt-out, you will still see non-personalized
            advertisements on the Website.
          </p>
          <p>
            The Website collects the following data using a cookie when serving
            personalized ads:
          </p>
          <ul>
            <li>IP Address</li>
            <li>Operating System type</li>
            <li>Operating System version</li>
            <li>Device Type</li>
            <li>Language of the website</li>
            <li>Web browser type</li>
            <li>Email (in hashed form)</li>
          </ul>
          <p>
            Mediavine Partners (companies listed below with whom Mediavine
            shares data) may also use this data to link to other end user
            information the partner has independently collected to deliver
            targeted advertisements. Mediavine Partners may also separately
            collect data about end users from other sources, such as advertising
            IDs or pixels, and link that data to data collected from Mediavine
            publishers in order to provide interest-based advertising across
            your online experience, including devices, browsers and apps. This
            data includes usage data, cookie information, device information,
            information about interactions between users and advertisements and
            websites, geolocation data, traffic data, and information about a
            visitor’s referral source to a particular website. Mediavine
            Partners may also create unique IDs to create audience segments,
            which are used to provide targeted advertising.
          </p>
          <p>
            If you would like more information about this practice and to know
            your choices to opt-in or opt-out of this data collection, please
            visit{' '}
            <a
              href='https://thenai.org/opt-out/'
              target='_blank'
              rel='noreferrer noopener nofollow'
            >
              National Advertising Initiative opt out page
            </a>
            . You may also visit{' '}
            <a
              href='http://optout.aboutads.info/#/'
              target='_blank'
              rel='noreferrer noopener nofollow'
            >
              Digital Advertising Alliance website
            </a>{' '}
            and{' '}
            <a
              href='http://optout.networkadvertising.org/#'
              target='_blank'
              rel='noreferrer noopener nofollow'
            >
              Network Advertising Initiative website
            </a>{' '}
            to learn more information about interest-based advertising. You may
            download the AppChoices app at{' '}
            <a
              href='https://youradchoices.com/appchoices'
              target='_blank'
              rel='noreferrer noopener nofollow'
            >
              Digital Advertising Alliance’s AppChoices app
            </a>{' '}
            to opt out in connection with mobile apps, or use the platform
            controls on your mobile device to opt out.
          </p>
          <p>
            For specific information about Mediavine Partners, the data each
            collects and their data collection and privacy policies, please
            visit{' '}
            <a
              href='https://www.mediavine.com/ad-partners/'
              target='_blank'
              rel='noreferrer noopener nofollow'
            >
              Mediavine Partners
            </a>
            .
          </p>
        </div>
      </div>
    </>
  )
}

export default Recs
